"use strict";
/// <reference types="waypoints"/>
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import 'modernizr';
require("core-js/stable/dom-collections/for-each");
require("waypoints/lib/noframework.waypoints");
var vue_1 = require("vue");
var App_vue_1 = __importDefault(require("./App.vue"));
var ease_component_1 = require("ease-component");
var scroll_to_1 = require("./scroll-to");
var tab_1 = require("./tab");
var collapse_1 = require("./collapse");
var collapse_menu_1 = require("./collapse-menu");
var swiper_slider_1 = require("./swiper-slider");
require("./../scss/_variables");
require("bootstrap/scss/bootstrap");
require("./../scss/main");
var Application = /** @class */ (function () {
    function Application() {
    }
    Application.prototype.run = function () {
        this.initScrollTo();
        this.initTab();
        this.initCollapse();
        this.initCollapseMenu();
        this.initSlider();
        this.initWaypoints();
    };
    Application.prototype.initScrollTo = function () {
        var items = document.querySelectorAll('.j-scroll-component');
        items.forEach(function (item) {
            var element = item;
            if (element.dataset.scrollHref) {
                var scrollTarget = document.querySelector(element.dataset.scrollHref);
                if (scrollTarget !== null) {
                    new scroll_to_1.ScrollTo({
                        triggerElement: item,
                        destination: scrollTarget,
                        ease: ease_component_1.inOutSine,
                        scrollDuration: element.dataset.scrollDuration ? parseInt(element.dataset.scrollDuration) : 1000
                    });
                }
            }
        });
    };
    Application.prototype.initTab = function () {
        var tabList = document.querySelectorAll('.j-tab-component');
        tabList.forEach(function (tab) {
            new tab_1.Tab({
                element: tab
            });
        });
    };
    Application.prototype.initCollapse = function () {
        var collapseList = document.querySelectorAll('.j-collapse-component');
        collapseList.forEach(function (collapse) {
            new collapse_1.Collapse({
                element: collapse
            });
        });
    };
    Application.prototype.initCollapseMenu = function () {
        var collapseList = document.querySelectorAll('.j-collapse-menu-component');
        collapseList.forEach(function (collapse) {
            new collapse_menu_1.CollapseMenu({
                element: collapse
            });
        });
    };
    Application.prototype.initSlider = function () {
        var sliderList = document.querySelectorAll('.j-slider-component');
        sliderList.forEach(function (slider) {
            new swiper_slider_1.SwiperSlider({
                element: slider
            });
        });
    };
    Application.prototype.initForms = function () {
        var app = (0, vue_1.createApp)(App_vue_1.default);
        app.mount('#app');
    };
    Application.prototype.initWaypoints = function () {
        var items = document.querySelectorAll('.j-waypoint-target');
        items.forEach(function (item) {
            var element = item;
            if (!element.dataset.offsetElement) {
                return;
            }
            var offsetElement = document.querySelector(element.dataset.offsetElement);
            if (offsetElement === null) {
                return;
            }
            new Waypoint({
                element: offsetElement,
                offset: function () {
                    return -offsetElement.offsetHeight;
                },
                handler: function (direction) {
                    if (direction == 'down') {
                        element.classList.add('d-block');
                    }
                    else {
                        element.classList.remove('d-block');
                    }
                }
            });
        });
    };
    return Application;
}());
document.addEventListener('DOMContentLoaded', function () {
    new Application().run();
});
